const progressDetailsExpandButtons = () => {
  const expandButtons = document.getElementsByClassName('lead-details-button');

  for (let i = 0; i < expandButtons.length; i += 1) {
    const button = expandButtons[i];
    button.addEventListener('click', (e) => {
      const { target } = e;
      const container = target.nextElementSibling;
      target.innerText = target.innerText === 'View Details'
        ? 'Hide Details'
        : 'View Details';

      container.classList.toggle('hidden');
    });
  }
};

const progressDetailsCheckCompletion = () => {
  const statuses = document.getElementsByClassName('note-status');
  const submit = document.getElementById('submit-button');

  const checkIfFormComplete = () => {
    if (Array.from(statuses).every((s) => s.value)) {
      submit.disabled = false;
    }
  };

  for (let i = 0; i < statuses.length; i += 1) {
    statuses[i].addEventListener('change', checkIfFormComplete);
  }
};

export {
  progressDetailsExpandButtons,
  progressDetailsCheckCompletion,
};
